<template>
    <NavBar />
    <router-view v-slot="{ Component }" class="content">
        <transition name="router-view-fade" mode="out-in">
            <component :is="Component" />
        </transition>
    </router-view>
    <Footer />
</template>

<script lang="ts">
import { defineComponent } from "vue";
import NavBar from "@/components/navigation/NavBar.vue";
import Footer from "@/components/Footer.vue";

export default defineComponent({
    components: { NavBar, Footer },
});
</script>

<style lang="scss">
@use "@/assets/global";
@import "../node_modules/katex/dist/katex.min.css";

body {
    font-family: Poppins, Helvetica, Arial, sans-serif;

    color: global.$text-color;
    @media (prefers-color-scheme: dark) {
        color: global.$dark-theme-text-color;
    }
    background-color: global.$background-color;
    @media (prefers-color-scheme: dark) {
        background-color: global.$dark-theme-background-color;
    }

    padding: 0px;
    margin: 0px;

    scroll-behavior: smooth;

    .content {
        flex: 1;
    }

    #app {
        flex-direction: column;
        display: flex;
        height: 100vh;
    }

    @media not all and (max-width: global.$mobile-width) {
        .router-view-fade-enter-active,
        .router-view-fade-leave-active {
            transition-property: opacity, background;
            transition-duration: 150ms;
        }

        .router-view-fade-enter-from,
        .router-view-fade-leave-to {
            opacity: 0;
            background-color: transparent;
        }
    }
}
</style>
